/* eslint-disable */
// import Swiper from "swiper/bundle";
//import Swiper from "swiper";

/* eslint-enable */

class AnimationWysiwygInsights {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleWysiwygInsights = this.sectionsContainer.querySelector('.single-cpt__text.wysiwyg-insights .u-wysiwyg');
		this.$wrapperLinksShare = this.sectionsContainer.querySelector('.single-cpt__text.wysiwyg-insights .wrapper-links-share');
		
		if (!this.$moduleWysiwygInsights)
			return;
		
		this.$moduleWysiwygInsightsChildrens = Array.from(this.$moduleWysiwygInsights.children);
	
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
        // Configuración inicial de GSAP
        gsap.set(this.$moduleWysiwygInsights, { opacity: 1 });
        this.$moduleWysiwygInsightsChildrens.forEach((child) => {
            gsap.set(child, { yPercent: 20, opacity: 0.0001, transformOrigin: 'center center' });
        });

        // Configuración inicial para .wrapper-links-share
        if (this.$wrapperLinksShare) {
            gsap.set(this.$wrapperLinksShare, { yPercent: 20, opacity: 0.0001, transformOrigin: 'center center' });
        }

        // Configuración de la animación principal
        this.initAnimate();
	}

	initAnimate() {
        // Mostrar el contenedor principal
        gsap.to(this.$moduleWysiwygInsights, {
            opacity: 1,
            duration: 1,
            scrollTrigger: {
                trigger: this.$moduleWysiwygInsights,
                start: 'top 70%',
            },
        });

        // Animar cada hijo individualmente al llegar al 60% de la pantalla
        this.$moduleWysiwygInsightsChildrens.forEach((child, index) => {
            gsap.to(child, {
                yPercent: 0,
                opacity: 1,
                duration: 1,
                ease: 'power4.out',
                scrollTrigger: {
                    trigger: child,
                    start: 'top 80%',
                },
            });
        });

        // Animar .wrapper-links-share al llegar al 80% de la pantalla
        if (this.$wrapperLinksShare) {
            gsap.to(this.$wrapperLinksShare, {
                yPercent: 0,
                opacity: 1,
                duration: 1,
                ease: 'power4.out',
                scrollTrigger: {
                    trigger: this.$wrapperLinksShare,
                    start: 'top 80%',
                },
            });
        }
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationWysiwygInsights;
